import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { apiPOST } from "../../utilities/apiHelpers";
import image from "../../../src/assest/image/LoginImage.png"

const VerifyOTP = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formData = location.state;

  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [errors, setErrors] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);

  const [timer, setTimer] = useState(300); // 5 minutes in seconds

  useEffect(() => {
    if (timer === 0) return;
    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timer]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  // Determine phone/email to display
  const displayContact = formData?.email;

  // Handle input change and move focus
  const handleChange = (element, index) => {
    const value = element.value;
    if (isNaN(value)) return;

    setOtp([...otp.map((d, idx) => (idx === index ? value : d))]);

    if (value !== "" && element.nextSibling) {
      element.nextSibling.focus();
    } else if (value === "" && element.previousSibling) {
      element.previousSibling.focus();
    }
  };

  // Handle keyboard navigation
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && e.target.value === "" && e.target.previousSibling) {
      e.target.previousSibling.focus();
    } else if (e.key === "ArrowRight" && e.target.nextSibling) {
      e.target.nextSibling.focus();
    } else if (e.key === "ArrowLeft" && e.target.previousSibling) {
      e.target.previousSibling.focus();
    }
  };

  // Validate OTP
  const validateOTP = () => {
    if (otp.includes("")) {
      return "Please enter the complete OTP.";
    }
    return "";
  };

  // SweetAlert toast
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  // Submit OTP
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateOTP();
    if (validationError) {
      setErrors(validationError);
      return;
    }
    setErrors("");
    setSubmitLoading(true);

    try {
      const payload = {
        otp: otp.join(""),
        email: formData.email,
      };
      const response = await apiPOST("v1/auth/verify-otp", payload);

      if (response.status === 200) {
        Swal.fire({
          title: "Success!",
          text: "OTP verified successfully",
          icon: "success",
        }).then(() => {
          navigate("/login");
        });
      } else {
        Toast.fire({
          title: "Error!",
          text: response.data?.data || "Something went wrong!",
          icon: "error",
        });
      }
    } catch (error) {
      Toast.fire({
        title: "Error",
        text:
          error.response?.data?.message ||
          error.message ||
          "An unexpected error occurred",
        icon: "error",
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // Resend OTP
  const resendOtp = async () => {
    try {
      const payload = { email: formData.email };
      const response = await apiPOST("v1/auth/resend-otp", payload);

      if (response.status === 200) {
        // --- ADD THIS LINE TO RESTART TIMER ---
        setTimer(300); 
        
        Toast.fire({
          title: "Success!",
          text: response?.data?.data || response.message || "OTP resent successfully",
          icon: "success",
        });
      } else {
        Toast.fire({
          title: "Error!",
          text: response.data?.data || "Something went wrong!",
          icon: "error",
        });
      }
    } catch (error) {
      Toast.fire({
        title: "Error",
        text:
          error.response?.data?.message ||
          error.message ||
          "An unexpected error occurred",
        icon: "error",
      });
    }
  };

  return (
    <div className="flex max-w-4xl md:mx-auto mt-20 border rounded-lg overflow-hidden shadow-lg mx-5">
      {/* <div
        style={{ backgroundColor: "#F1F9FF" }}
        className="hidden md:block lg:block flex-1 p-10 rounded-xl items-end"
      >
        <div className="mt-[100%]">
          <h2 className="text-2xl font-bold mb-4">Medicines, Home Delivered</h2>
          <p className="text-xs text-gray-400">
            Order any medicine or health product and we'll deliver it for free.
            Enjoy discounts on everything.
          </p>
        </div>
      </div> */}
      <div style={{ backgroundColor: '#F1F9FF' }} className="hidden sm:hidden flex-1 p-10 flex-col flex-wrap md:block lg:block rounded-xl m-2 justify-end">
        <div className="flex justify-center mb-6 mr-10">
          <img
            src={image}
            alt="Healthcare Products"
            className="w-80 h-auto object-contain drop-shadow-xl"
          />
        </div>
        <div className='mt-10'>
          <h2 className="text-2xl font-bold mb-4">Medicines, Home Delivered</h2>
          <p className="text-xs text-gray-400">
            Order any medicine or health product and we'll deliver it for free.
            Enjoy discounts on everything.
          </p>
        </div>
      </div>

      <div className="flex-1 p-10 bg-white">
        <div className="flex justify-between">
          <h2 className="text-2xl font-bold mb-4">Verify OTP</h2>
        </div>

        <div className="mb-8">

          <p className="text-gray-600 text-xs">
            Provide OTP sent to {displayContact}{" "}
            <span
              onClick={() => navigate(-1)}
              className="text-[#095D7E] no-underline cursor-pointer font-medium hover:underline"
            >
              Edit
            </span>
          </p>
        </div>



        <form onSubmit={handleSubmit} className="flex flex-col">
          <div>
            <div className="mb-2">
              <p className="text-gray-600 text-sm">Enter OTP</p>
            </div>
            <div className="flex justify-between mb-4">
              {otp.map((data, index) => (
                <input
                  key={index}
                  className="w-12 h-12 sm:w-16 sm:h-16 lg:w-16 lg:h-16 md:w-16 md:h-16 text-center rounded-lg border bg-[#F8F8F8]"
                  type="text"
                  name="otp"
                  maxLength="1"
                  value={data}
                  onChange={(e) => handleChange(e.target, index)}
                  onFocus={(e) => e.target.select()}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                />
              ))}
            </div>
            {errors && (
              <div className="text-red-500 text-sm mb-4">{errors}</div>
            )}
            {timer > 0 ? (
              <p className="text-sm text-gray-500 mb-4">
                Code expires in <span className="font-medium text-[#095D7E]">{formatTime(timer)}</span>
              </p>
            ) : (
              <p className="text-sm text-red-500 font-medium mb-4">OTP expired. Please request a new one.</p>
            )}
            <div className="text-left mb-24">
              {timer === 0 && (
              <buttom
                onClick={resendOtp}
                className="text-[#14967F] text-sm font-semibold no-underline cursor-pointer"
              >
                Resend OTP?
              </buttom>
              )}
            </div>
          </div>

          <button
            type="submit"
            className="w-full py-2 text-white font-semibold bg-[#095D7E] rounded-full"
            disabled={submitLoading}
          >
            {submitLoading ? "Verifying..." : "Verify OTP"}
          </button>
        </form>

        <p className="mt-4 text-xs text-gray-600">
          New on mediiapp?{" "}
          <Link to="/signup" className="text-[#095D7E] no-underline">
            Sign up
          </Link>
        </p>
      </div>
    </div>
  );
};

export default VerifyOTP;
